import { Filter } from '@devexpress/dx-react-grid'

const filterByOrder = (value: any, filter: Filter, row: any) => {
  if (!filter.value.length) {
    return true
  }

  const filteredOrder = !isNaN(filter?.value) ? parseInt(filter?.value, 10) : null

  if(filteredOrder === null){
    return false
  }

  return filteredOrder === (value + 1)

}

export default filterByOrder
